import { Controller } from "@hotwired/stimulus"

// FilterPanel — toggle for the catalog's collapsible filter panel.
// Persists open/closed state in localStorage so it survives navigations.
// Also auto-submits the wrapping form when any <select> inside it changes
// (sort dropdown, quality dropdown — the multiselect dropdowns are checkboxes
// and require an explicit "Search" button by design).
//
// Markup (see app/views/movies/index.html.erb):
//   <%= form_with ..., data: {
//         controller: "filter-panel",
//         action:     "change->filter-panel#submitOnSelectChange"
//       } do |form| %>
//     <div data-filter-panel-target="toggle"
//          data-action="click->filter-panel#toggle">…</div>
//     <div data-filter-panel-target="panel">…</div>
//   <% end %>
const STORAGE_KEY = "filterDisplayState"

export default class extends Controller {
  static targets = ["toggle", "panel"]

  connect() {
    if (this.readStorage() === "show") this.setOpen(true)
  }

  toggle() {
    this.setOpen(!this.toggleTarget.classList.contains("active"))
  }

  submitOnSelectChange(event) {
    if (event.target.tagName !== "SELECT") return
    if (typeof this.element.requestSubmit === "function") {
      this.element.requestSubmit()
    } else {
      this.element.submit()
    }
  }

  // ---

  setOpen(open) {
    this.toggleTarget.classList.toggle("active", open)
    this.panelTarget.classList.toggle("active", open)
    this.writeStorage(open ? "show" : "hide")
  }

  readStorage() {
    try { return window.localStorage.getItem(STORAGE_KEY) } catch (_) { return null }
  }

  writeStorage(value) {
    try { window.localStorage.setItem(STORAGE_KEY, value) } catch (_) { /* storage disabled */ }
  }
}
